import { useState } from 'react';
import { API_CONFIG } from '../config/apiConfig';
import { apiClient } from '../utils/apiClient';

interface UpdateOrgDetailsParams {
  p_return_header_id: string;
  p_whid: string;
  p_reopen_order: string;
}

interface UpdateOrgDetailsResponse {
  success: boolean;
  return_status: string;
  return_message: string;
}

export const useUpdateOrgDetails = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateOrgDetails = async (params: UpdateOrgDetailsParams): Promise<UpdateOrgDetailsResponse | null> => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.UPDATE_TO_ORG_DETAILS, {
        params
      });

      if (response.data.success) {
        return response.data;
      } else {
        setError(response.data.error || 'Update failed');
        return null;
      }
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || err.message || 'Failed to update organization details';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateOrgDetails,
    loading,
    error
  };
};